import PropTypes from 'prop-types';
import styles from './payment-methods.module.less';
import { useSelector } from 'react-redux';
import { getVippsForm } from '../../../payment/payment-selectors';
import { ContextMessage } from '@sb1/ffe-messages-react';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import { MULTIPLE_ERRORS_CONTEXT_TITLE_TEXT_KEY } from '../../i18n/project-i18n-model';

const PaymentErrorMessage = ({ amountError }) => {
    const vippsForm = useSelector((state) => getVippsForm(state));
    const stripeForm = useSelector((state) => state.stripeForm);
    const invoiceForm = useSelector((state) => state.invoiceForm);
    const rewardGiverInfoForm = useSelector((state) => state.rewardGiverInfoForm);
    const texts = useI18nTexts([MULTIPLE_ERRORS_CONTEXT_TITLE_TEXT_KEY]);

    const allErrors = [
        amountError?.amount ?? false,
        ...Object.values(stripeForm?.errors || {}),
        ...Object.values(vippsForm?.errors || {}),
        ...Object.values(invoiceForm?.errors || {}),
        ...Object.values(rewardGiverInfoForm?.errors || {}),
    ].filter(Boolean);

    const errorMessage = allErrors.find(Boolean);
    if (!errorMessage) {
        return;
    }

    if (allErrors.length > 1) {
        return (
            <ContextMessage
                className={styles.paymentErrorMessageContainer}
                type="error"
                compact
                header={texts[MULTIPLE_ERRORS_CONTEXT_TITLE_TEXT_KEY]}
            >
                <ul>
                    {allErrors.map((error, index) => (
                        <li key={index} className={styles.errorList}>
                            {error}
                        </li>
                    ))}
                </ul>
            </ContextMessage>
        );
    }
    return (
        <ContextMessage className={styles.paymentErrorMessageContainer} type="error" compact>
            {errorMessage}
        </ContextMessage>
    );
};

PaymentErrorMessage.propTypes = {
    amount: PropTypes.number,
    rewards: PropTypes.array,
    disabled: PropTypes.bool,
    isCart: PropTypes.bool,
};

export default PaymentErrorMessage;
